import { ArticleService, type ArticlePremiumDO } from "./article.service"
import { isFrenchPath } from "../../../internationalize/i18n.service"


export class ArticlePremiumContent extends HTMLElement {
    private language: 'french' | 'english' = "french"
    private slug: string = document.body.getAttribute("slug") ?? ""

    constructor(private articleService: ArticleService = window.tbwServices.articleService) {
        super()
    }

    async connectedCallback() {
        if (window.tbwServices.authService.isAuthenticated) {
            this.language = isFrenchPath() ? "french" : "english"
            await this.render()
        }
    }

    async render() {
        this.innerHTML = '<p class="premium-content-loading">Loading...</p>'
        try {
            const content = await this.getArticleContent()
            this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium">
                <div class="text-rich-text w-richtext">
                    ${content.premiumContent}
                </div>
            </div>
        </tbw-auth-state>
        `
        } catch {
            this.innerHTML = '<p class="premium-content-error">Unable to load content</p>'
            return
        }
        // Dispatch event after content is actually in the DOM
        // Use setTimeout to ensure the browser has painted the content
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent("premiumContentLoaded", {
                bubbles: true,
                cancelable: true
            }))
        }, 0)
    }

    async getArticleContent(): Promise<ArticlePremiumDO> {
        const content = await this.articleService.get(this.slug, this.language)
        return content
    }
}